<template>
  <div class="l-img-card">
    <div class="img">
        <l-img :src='src'></l-img>      
    </div>
    <h4 class="title">
        {{title}}
    </h4>
  </div>
</template>

<script>
export default {
    name: 'l-img-card',
    props:{
        src: {
            default: ''
        },
        title: {
            default: ''
        },
    }
}
</script>
<style lang="scss" scoped>

.l-img-card{
    overflow: hidden;
    position: relative;
    height: 100%;

    .img{
        height: 100%;
        transition: all .5s;
        
        &:hover{
            transform: scale(1.1,1.1)
        }
    }

    .title{
        $h: 60px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        height: $h;
        background: rgba(000, 000, 000, .4);
        line-height: $h;
        text-align: center;
        font-size: $font_size_sub_title;
        color: $font_color_light;
    }
    
}
    
</style>